import Icon from "~/ui/Icon";
import { AVAILABLE_SCORES } from "~/ui/StarInput";
import intervalRound from "~/kernel/numbers/intervalRound";

type ScoreProps = {
  value: number | null;
  reviewCount: number;
  onClick?: () => void;
};

export default function Score({ onClick, value, reviewCount }: ScoreProps) {
  return (
    <button className="text-slate-500 hover:underline" onClick={onClick}>
      <Icon name="star" className="text-yellow-500" />{" "}
      {intervalRound(value ?? 0, 0.5)} / {Math.max(...AVAILABLE_SCORES)} (
      {reviewCount})
    </button>
  );
}
